import { Button } from './button'
import { GenericDropdown } from './generic-dropdown'
import { useStyles } from './dropdown-button.style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons'

export const DropdownButton = function ({ className, DropdownItems, ...props }) {
  const classes = useStyles()

  return (
    <GenericDropdown
      Target={
        <Button
          className={`${classes.button} ${className}`}
          data-qa="dropdown-button-open"
          type="button"
          {...props}
        >
          <FontAwesomeIcon className={classes.icon} icon={faChevronDown}/>
        </Button>
      }
      DropdownItems={DropdownItems}
      placement="bottom-end"
    />
  )
}
